import { render, staticRenderFns } from "./cookie-category-modal.vue?vue&type=template&id=924bb540"
import script from "./cookie-category-modal.vue?vue&type=script&lang=js"
export * from "./cookie-category-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports